<div class="modal-container">
  <div class="comparison-close sticky-close">
    <a (click)="close()" tabindex="1" class="close-button">
      <img src="/assets/svgs/icons/close-black.svg" class="svg icon" />
    </a>
  </div>
  <div class="grid grid-wrapper">
    <div class="cell cell-large-col-span-12 bg-light comparison-header padding-medium">
      <h2 class="margin-bottom-small font-700"> Compare our car insurance covers</h2>
      <div class="block bg-lightSurface">
        <label class="font-700"> Third Party Property</label>
        <p class="text-small"> Covers accidental damage caused to other people's property if the driver of your car is at fault.</p>
        <p class="text-small">Eligible customers can also buy optional Fire &amp; Theft Cover, which provides cover up to the lesser of $10,000 or the market value of your car, if your car suffers loss or damage due to theft or fire.</p>
        <label class="font-700">Comprehensive</label>
        <p class="text-small"> Covers accidental loss or damage to your car, including car accidents, theft, fire and natural events like hail and flood, plus accidental damage caused to other people's property if the driver of your car is at fault.</p>
      </div>
    </div>
  </div>
  
  <div class="grid grid-wrapper">
    <div class="cell cell-large-col-span-12">
      <h4 class="margin-top-medium margin-bottom-small"> Cover summary</h4>
      <div class="margin-vertical-small">
        <div class="table-heading-row">
          <div class="grid padding-vertical-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6"></div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <label class="text-small text-black"> Third Party Property</label>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-2">
              <label class="text-small text-black"> Comprehensive</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="margin-bottom-large">
    <div class="grid grid-wrapper">
      <ul class="cell cell-large-col-span-12 product-cover list-style-none padding-none">
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6 padding-right-large">
              <label class="text-small font-700 text-black margin-bottom-xsmall">Collision</label>
              <div class="text-small text-black">Your car suffers loss or damage due to a collision.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall text-black">Up to $3,000 if caused by another uninsured driver and policy conditions are met.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-1">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6 padding-right-large">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Theft or fire</label>
              <div class="text-small text-black">Your car is damaged as a result of theft, attempted theft or fire.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall text-black"> Up to the lesser of $10,000 or the market value of your car, if the optional Fire &amp; Theft cover is purchased.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-1">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6 padding-right-large">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Legal Liability Cover</label>
              <div class="text-small text-black">We&apos;ll cover the driver of your car for damage to someone else's vehicle or property, caused by the use of your car.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall text-black"> Up to $20 million</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-1">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall text-black"> Up to $20 million</div>
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6 padding-right-large">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Natural events</label>
              <div class="text-small text-black">Your car suffers loss or damage caused by natural events like hail, storm, flood and bushfire.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-1">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6 padding-right-large">
              <label class="text-small font-700 text-black margin-bottom-xsmall">Malicious act</label>
              <div class="text-small text-black">Your car suffers loss or damage as a result of a malicious act.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-1">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Pay As You Drive Cover</label>
              <div class="text-small text-black">Save by choosing a range from 1,000 to 15,000 kms that your car will drive in a year.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-1">
              <div class="text-xsmall"> Optional</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  
  
  <div class="grid grid-wrapper">
    <div class="cell cell-large-col-span-12">
      <h4 class="margin-top-medium margin-bottom-small"> Additional benefits</h4>
      <div class="margin-vertical-small">
        <div class="table-heading-row">
          <div class="grid padding-vertical-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6"></div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
                <label class="text-small text-black">Third Party Property</label>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
              <label class="text-small large-3 text-black">Comprehensive</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="margin-bottom-large">
    <div class="grid grid-wrapper">
      <ul class="cell cell-large-col-span-12 product-cover list-style-none padding-none">
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> New for old car replacement</label>
              <div class="text-small text-black">We'll replace your car with a new one if it's written off and you're the first registered owner.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-1">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall text-black"> Up to 2 years</div>
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Theft and damage cover</label>
              <div class="text-small text-black">We'll pay for theft or damage to personal property in the car, that is designed to be worn or carried, such as clothes or bags.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $500, if the optional Fire &amp; Theft cover is purchased.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-1">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $500</div>
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Emergency travel and accommodation</label>
              <div class="text-small text-black">We'll pay for your necessary travel and accommodation if your car is damaged by a covered incident, can't be safely driven and is over a certain number of kms from home.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $500, if the optional Fire &amp; Theft cover is purchased. Cover only applies if 200 kms or more away from home.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $500. Cover only applies if 200 kms or more away from home.</div>
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Towing costs</label>
              <div class="text-small text-black">We&apos;ll cover the reasonable costs of towing a damaged car to the nearest safe and secure place. We will also cover the reasonable costs of towing your damaged car to an approved repairer.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Reasonable costs, if optional Fire & Theft cover is purchased and your claim is for fire, theft or attempted theft of your car.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Reasonable costs.</div>
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Essential repairs</label>
              <div class="text-small text-black">We&apos;ll pay for essential temporary repairs to restore your car to a roadworthy and safe condition so that you can drive to your intended destination.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $500, if optional Fire & Theft cover is purchased.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $500.</div>
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Hire car after theft</label>
              <div class="text-small text-black">If your car is stolen, we'll either organise the hire of a car or reimburse you the cost of a hire car to get you back on the road.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $70 per day for up to 14 days if optional Fire & Theft cover is purchased.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $70 per day for up to 14 days.</div>
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Trailer and Caravans</label>
              <div class="text-small text-black">We will pay to cover the costs of any accidental loss or damage to a trailer or caravan that occurs while it was attached to your car. Conditions apply.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall text-black">Up to $1000.</div>
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Car transportation</label>
              <div class="text-small text-black">We will pay for loss or damage to your car caused whilst it is being transported (including loading and unloading, and by road, rail, ship or air) between any places in Australia. Conditions apply.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Child safety seats and prams</label>
              <div class="text-small text-black">We'll pay to help cover the cost of replacing child seats, baby capsules and prams damaged or stolen in an incident involving your car.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            </div>
          </div>
        </li>
        <li class="padding-bottom-small">
          <div class="grid margin-top-xsmall">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-3 cell-small-col-span-6">
              <label class="text-small font-700 text-black margin-bottom-xsmall"> Locks and keys</label>
              <div class="text-small text-black">If your keys are stolen, we&apos;ll pay to replace or recode your car's locks and keys.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-start-4 cell-medium-col-span-3 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $1000, if optional Fire & Theft cover is purchased.</div>
            </div>
            <div class="cell cell-large-col-span-4 cell-medium-col-span-2 cell-small-col-span-3 cell-tiny-col-span-2">
              <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
              <div class="text-xsmall"> Up to $1000.</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
  
  
  <div class="grid grid-wrapper padding-bottom-medium">
    <div class="cell cell-large-col-span-12">
      <div class="text-small margin-right-small">Benefits subject to terms and conditions, including exclusions and limits (and sub-limits) of the insurance policy. When making decisions about the product you should always refer to the <a [href]="dataObj.apiEndpoint + dataObj.pds?.url" target="_blank">Product Disclosure Statement (PDS)</a> and consider the relevant <a [href]="dataObj.apiEndpoint + dataObj.tmd?.url" target="_blank">Target Market Determination (TMD)</a></div>
    </div>
  </div>
</div>